import React from "react";
import './searchFilterComponent.scss';
import SearchComponent from "./SearchComponent";
import FilterComponent from "./FilterComponent";
import VisibilityComponent from "./VisibilityComponent";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DisabledButtonWithToolTip from "../../Theme/DisabledButtonWithToolTip";
import AppliedFiltersComponent from "./AppliedFiltersComponent";
import { useSelector } from "react-redux";
import { NO_ACCESS_TEXT } from "../../App/App";
import { VisibilityType } from "../../../constants/filter.constants";

/**
 * @param {Object} [props]
 * @param {*} [props.leftSide]
 * @param {string} [props.passedMainStyles]
 * @param {React.RefObject} [props.passedRef]
 * @param {string} [props.searchValue]
 * @param {function} [props.searchOnChange]
 * @param {function} [props.searchOnCross]
 * @param {function} [props.onSortClick]
 * @param {Array} [props.headersList]
 * @param {function} [props.updatedHeaderList]
 * @param {string} [props.visibilityType]
 * @param {Array<{ label: string, key: string, value: boolean, renderComponent: function? }>} [props.visibilityFilters]
 * @param {function} [props.onVisibilityFilterChange]
 * @param {Array<{ FieldKey: string, FieldName: string, 
* SortOrder: number, Visibility: boolean, IsEditable: boolean, EditableContent: string | null }>} [props.orderData]
* @param {function} [props.onFilterClick]
* @param {Array<{ img: string, label: string, value: string }>} [props.passedFilterList]
* @param {function} [props.setRef]
* @param {function} [props.setOrderData]
* @param {function} [props.onResetClick]
* @param {function} [props.onFilterClick]
* @param {function} [props.onVisibilityFilterChange]
* @param {function} [props.lastButtonOnClick]
* @param {boolean} [props.isLastButtonDisabled]
* @param {boolean} [props.showLastButton]
* @param {string} [props.lastButtonLabel]
* @param {Array<{ img: string, label: string, value: string }>} [props.selectedFilterList]
* @param {function} [props.setSelectedFilterList]
* @param {function} [props.childFilterItem]
* @param {function} [props.childAppliedFilterItem]
* @param {string} [props.sortOptionTooltip]
* @param {function} [props.lastButtonChild]
* @param {boolean} [props.noToSearch]
* @param {boolean} [props.showFiltersTitle]
* @param {string} [props.searchFilterWrapperClassName]
* @param {function} [props.setOrderData]
* @param {boolean} [props.disableSearch]
*/
export const SearchFilterComponent = ({
    isWhite = false,
    leftSide,
    rightSide,
    passedMainStyles = '',
    searchValue,
    passedRef,
    passedFilterList = [],
    onFilterClick = () => { },
    setRef = () => { },
    searchOnChange = (e) => { },
    searchOnCross = () => { },
    onSortClick = () => { },
    visibilityType = VisibilityType.TABLE,
    visibilityFilters = [],
    onVisibilityFilterChange = () => { },
    orderData = [],
    setOrderData = () => { },
    isLastButtonDisabled = false,
    showLastButton = true,
    lastButtonLabel,
    lastButtonOnClick = () => { },
    childFilterItem,
    selectedFilterList = [],
    setSelectedFilterList = () => { },
    childAppliedFilterItem,
    onResetClick = () => { },
    sortOptionTooltip,
    lastButtonChild,
    noToSearch = false,
    showFiltersTitle,
    searchFilterWrapperClassName = "",
    checkId = "",
    noToShowSearch = false,
    showVisibilityComponent = true
}) => {
    const blockSearch = useSelector(state => state?.actioncentre?.refreshCreateTaskModalModule);
    return (
        <div className={`${passedMainStyles}`}>
            <div className={`d-flex align-items-center justify-content-between ${searchFilterWrapperClassName ?? ''}`}>
                {
                    leftSide ? leftSide : <></>
                }
                <div className="d-flex align-items-center search-filter-component"
                    style={{
                        // marginRight: '200px',
                        gap: '4px'
                    }}
                >
                    {
                        rightSide && rightSide
                    }
                    {
                        !noToShowSearch &&
                        <SearchComponent
                            value={searchValue}
                            onChange={searchOnChange}
                            onCross={searchOnCross}
                            passedRef={passedRef}
                            setRef={setRef}
                            isWhite={isWhite}
                            noToSearch={noToSearch}
                            checkId={checkId}
                            disabled={blockSearch}
                        />
                    }
                    <FilterComponent
                        filterList={passedFilterList}
                        childFilterItem={childFilterItem}
                        onFilterClick={onFilterClick}
                        isWhite={isWhite}
                        showTitle={showFiltersTitle}
                    />
                    {
                        sortOptionTooltip ? <OverlayTrigger
                            placement="bottom"
                            trigger={["hover", "focus"]}
                            delay={{ show: 200, hide: 250 }}
                            overlay={
                                <Tooltip id={`tooltip-1365`}>
                                    {sortOptionTooltip}
                                </Tooltip>
                            }
                        >
                            <div
                                style={{ width: '32px', height: '32px' }}
                                className="d-flex align-items-center justify-content-center"
                            >
                                <img
                                    alt=""
                                    width={17}
                                    height={15}
                                    src={isWhite ? "/images/sort-icon-white.svg" : "/images/sort-icon.svg"}
                                />
                            </div>
                        </OverlayTrigger> :
                            <div
                                style={{ width: '32px', height: '32px' }}
                                className="d-flex align-items-center justify-content-center pointer"
                                onClick={() => {
                                    onSortClick();
                                }}
                            >
                                <img
                                    alt=""
                                    width={17}
                                    height={15}
                                    src={isWhite ? "/images/sort-icon-white.svg" : "/images/sort-icon.svg"}
                                />
                            </div>
                    }
                    {showVisibilityComponent &&
                        <VisibilityComponent
                            visibilityType={visibilityType}
                            filterList={visibilityFilters}
                            onFilterChange={onVisibilityFilterChange}
                            orderData={orderData}
                            setOrderData={setOrderData}
                            isWhite={isWhite}
                        />
                    }
                    {
                        showLastButton && <>
                            {
                                lastButtonChild ? lastButtonChild : <>
                                    {
                                        isLastButtonDisabled ? <DisabledButtonWithToolTip
                                            buttonText={lastButtonLabel ?? 'Add'}
                                            noAccessText={NO_ACCESS_TEXT}
                                        /> : <Button
                                            className="hg-blue-btn py-1 px-2"
                                            onClick={() => {
                                                lastButtonOnClick();
                                            }}
                                        >
                                            {lastButtonLabel ?? 'Add'}
                                        </Button>
                                    }
                                </>
                            }
                        </>
                    }
                </div>
            </div>
            {
                selectedFilterList?.length > 0 &&
                <AppliedFiltersComponent
                    childAppliedFilterItem={childAppliedFilterItem}
                    onResetClick={onResetClick}
                />
            }
        </div>
    );
};

export default SearchFilterComponent;
